module.exports = __webpack_public_path__ + "static/media/bacchus-logo-white.bae00433.png";